import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';

type AlertType = 'success' | 'error' | 'warning' | 'info';

@Component({
    selector: 'app-alert-modal',
    template: `
        <div
            class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[9999]"
        >
            <div class="relative bg-white p-6 rounded-2xl shadow-lg w-[300px]">
                <div class="flex flex-col justify-center items-center">
                    <!-- <img [src]="icon" class="w-20 h-20" alt="{{ type }}" /> -->
                    <p class="mb-4 mt-2 text-[#122456] text-center">
                        {{ message }}
                    </p>
                </div>
                <div class="flex justify-center">
                    <button
                        class="px-4 py-2 rounded-lg bg-[#3A943B] text-white cursor-pointer"
                        (click)="close()"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    `,
})
export class AlertModalComponent {
    @Input() message: string = 'Berhasil!';
    @Input() type: AlertType = 'success';

    private result$ = new Subject<void>();

    get icon() {
        switch (this.type) {
            case 'success':
                return 'assets/images/ezty/success-icon.png';
            case 'error':
                return 'assets/images/ezty/error-icon.png';
            case 'warning':
                return 'assets/images/ezty/warning-icon.png';
            case 'info':
                return 'assets/images/ezty/info-icon.png';
            default:
                return 'assets/images/ezty/info-icon.png';
        }
    }

    close() {
        this.result$.next();
        this.result$.complete();
    }

    getResult() {
        return this.result$.asObservable();
    }
}
